import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { resolveImageUrl } from "../components/ImageUpload";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 py-12 sm:py-16" data-testid="blog-page">
      <div className="mb-10 sm:mb-12">
        <div className="overline text-zinc-500 mb-3">Journal</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">Fruit Blossoms Journal</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group" data-testid={`blog-post-${p.id}`}>
            <div className="rounded-2xl overflow-hidden bg-white border border-zinc-100 hover:shadow-lg transition">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={resolveImageUrl(p.cover_image_url)} alt={p.title}
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="overline text-[#F74B64] mb-2">{p.category}</div>
                <div className="font-display font-bold text-xl leading-tight">{p.title}</div>
                <p className="text-sm text-zinc-500 mt-2">{p.excerpt}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
